// extracted by mini-css-extract-plugin
export var platform = "index-module--platform--B0CCL";
export var platform_item = "index-module--platform_item--bF97E";
export var text = "index-module--text--FJlvQ";
export var main = "index-module--main--Sjv2T";
export var second_title = "index-module--second_title--nAtGb";